<template>
    <div>
        <sidebar
            :show-sidebar="showSidebar"
            :settings="settings"
            @closesidebar="closesidebar"
            @selectprimaryfilter="selectPrimaryFilter"
            :selectedPrimaryFilter="selectedPrimaryFilter"
            :showPois="showPois"
        ></sidebar>
        <sidebar-overlay
            :show-sidebar="showSidebar"
            @closesidebar="closesidebar"
        ></sidebar-overlay>
        <router-view
            @opensidebar="opensidebar"
            @closesidebar="closesidebar"
            :settings="settings"
            :show-sidebar="showSidebar"
        ></router-view>

        <div v-if="$route.name === 'vanilla'">
            <hammer-vanilla
                @opensidebar="opensidebar"
                :settings="settings"
            ></hammer-vanilla>
        </div>
        <div v-else>
            <hammer-map
                @opensidebar="opensidebar"
                :settings="settings"
                :selectedPrimaryFilter="selectedPrimaryFilter"
                @selectprimaryfilter="selectPrimaryFilter"
                @selectsecondaryfilter="selectSecondaryFilter"
                :showPois="showPois"
            ></hammer-map>
        </div>
    </div>
</template>

<script>
/**
        <hammer-vanilla
            @opensidebar="opensidebar"
            :settings="settings"
        ></hammer-vanilla>
 */
export default {
    data() {
        return {
            showSidebar: false,
            settings: window.config.settings,
            selectedPrimaryFilter: null,
            showPois: false,
        };
    },
    methods: {
        opensidebar() {
            this.showSidebar = true;
            this.$gtag.event('MENU_OPEN', {
                event_category: 'MENU',
            });
        },
        closesidebar() {
            this.showSidebar = false;
        },
        selectPrimaryFilter(filter) {
            this.selectedPrimaryFilter = filter;
        },
        selectSecondaryFilter(filter) {
            const key = this.selectedPrimaryFilter.children.findIndex(
                (item) => item === filter,
            );
            this.selectedPrimaryFilter.children[key].active = filter.active;
        },
    },
};
</script>
